import { useParams } from "react-router-dom";
import {Tabs, Tab, Row, Col} from "react-bootstrap";
import { IRouteActiveTab } from "../../../types/IRouteActiveTab";
import CrdMudelSingle from "./CrdMudelSingle";
import CrdMudel from "./CrdMudel";
import CrdMudelTextArea from "./CrdMudelTextArea";
import Interreg_logo from "../../../images/Interreg_logo.png";
import {useTranslation} from 'react-i18next';

const CrdMudelTabs = (props: any) => {

    const { activeTab } = useParams() as IRouteActiveTab;
    const {t} = useTranslation();

    function setTabKey(newKey: string | null) {
        props.history.replace({pathname: "/crdmudel/" + newKey});
    }
    
    function getTabKey() {
        let allowedKeys = ["single", "multiple", "textarea"];
        if (allowedKeys.includes(activeTab)) {
            return activeTab;
        }
        return "single";
    }
 
    return (
        <>
            {t('crdMudelTabTitle')}<br />
            <Tabs activeKey={getTabKey()} onSelect={(k) => setTabKey(k)} id="uncontrolled" className="mb-3">
                <Tab eventKey="single" title={t('tabSingleCoordTitle')}>
                    <CrdMudelSingle isValga = {false}/>
                </Tab>
                <Tab eventKey="multiple" title={t('tabMultipleCoordsTitle')}>
                    <CrdMudel isValga = {false}/>
                </Tab>
                <Tab eventKey="textarea" title={t('tabTextareaCoordsTitle')}>
                    <CrdMudelTextArea isValga = {false}/>
                </Tab>
            </Tabs>
            <a href="https://geoportaal.maaamet.ee/est/Teenused/Geodeesia-kalkulaatorid-p142.html" className="link">{t('usingCalculators')}</a><br /><br />
            <Row>
                <Col>
                    {t('interregProject')}
                </Col>
                <Col>
                    <img className="interreg-logo" src={Interreg_logo} alt="Interreg logo"/>
                </Col>
            </Row>
        </>
    );
}

export default CrdMudelTabs;

